import React from 'react';
import NumberFormat from 'react-number-format';
import {
  FormControl,
  Grid,
  TextField
} from '@material-ui/core';


const QuoteItemRowTotal = ({
  item,
  selectedDataSource
}) => {
  const {
    productAttributes,
    productDiscounts
  } = selectedDataSource;

  const {
    discountType,
    discount,
    fixedPrice,
    qty
  } = item;

  const savings = +productAttributes?.savings || 0;

  const discountOptions = (productDiscounts || []).reduce((acc, option) => {
    const { price_type, price, sort_order } = option;

    acc[price_type] = [...(acc[price_type] || []), { price_type, price, sort_order }];
    acc[price_type].sort((a, b) => a.price - b.price);

    return acc;
  }, {});

  const selectedDiscount = discountOptions[discountType]?.find((option) => discount === option?.price && discountType === option?.price_type);
  let discountPrice;

  if (discountType && discount) {
    if (discountType === 'percent') {
      discountPrice = fixedPrice * discount / 100;
    } else {
      discountPrice = discount;
    }
  } else {
    discountPrice = (selectedDiscount?.price_type === 'percent')
      ? fixedPrice * (selectedDiscount?.price || 0) / 100
      : selectedDiscount?.price || 0;
  }

  const rowTotal = qty * Math.abs(fixedPrice - discountPrice - savings);

  return (
    <Grid item xs={12} lg>
      <FormControl variant="outlined" fullWidth>
        <NumberFormat
          customInput={TextField}
          variant="outlined"
          name="rowTotal"
          label="Row Total"
          thousandSeparator
          disabled
          value={rowTotal}
          prefix="$"
          fixedDecimalScale
          decimalScale={2}
        />
      </FormControl>
    </Grid>
  );
};

export default QuoteItemRowTotal;
